export default "__VITE_ASSET__BRDvCmLw__"